<template>
  <div class="order">
    <van-tabs v-model="tabActive" sticky :offset-top="`${94*$utils.ratio}px`" animated swipeable>
      <van-tab :title="personInfo.role !== 'STUDENT' ? '粤教培训':'在线学习'" :name="0">
        <ul class="statusList">
          <li
            class="item"
            v-for="(item,index) in statusList"
            :key="index"
            @click="statusActive = item.key"
            :class="{'activeItem':statusActive === item.key}"
          >{{item.name}}</li>
        </ul>
        <van-pullRefresh  v-model="page.refreshing" @refresh="onRefresh">
          <Empty v-if="page.totalCount === 0" />
          <van-list
            v-model="page.loading"
            :finished="page.finished"
            @load="onLoad"
            v-else
          >
            <OrderItem
              @cancel="cancel(item)"
              @clickBuy="pay(item)"
              v-for="(item,index) in page.list"
              :key="index"
              :obj="item"
              @click="handleItem(item)"
            />
            <template #finished>
              <van-divider style="width:50%;margin:20px auto;">滑到底啦</van-divider>
            </template>
          </van-list>
        </van-pullRefresh>
      </van-Tab>
      <van-tab title="优秀课例" :name="1" v-if="personInfo.role !== 'STUDENT'">
        <ul class="statusList">
          <li
            class="item"
            v-for="(item,index) in statusList"
            :key="index"
            @click="statusActive = item.key"
            :class="{'activeItem':statusActive === item.key}"
          >{{item.name}}</li>
        </ul>
        <van-pullRefresh v-model="page.refreshing" @refresh="onRefresh">
          <Empty v-if="page.totalCount === 0" />
          <van-list
            v-model="page.loading"
            :finished="page.finished"
            @load="onLoad"
            v-else
          >
            <OrderItem
              @cancel="cancel(item)"
              @clickBuy="pay(item)"
              v-for="(item,index) in page.list"
              :key="index"
              :obj="item"
              @click="handleItem(item)"
            />
            <template #finished>
              <van-divider style="width:50%;margin:20px auto;">滑到底啦</van-divider>
            </template>
          </van-list>
        </van-pullRefresh>
      </van-tab>
      <van-tab title="教学资源" :name="2">
        <ul class="statusList">
          <li
            class="item"
            v-for="(item,index) in statusList"
            :key="index"
            @click="statusActive = item.key"
            :class="{'activeItem':statusActive === item.key}"
          >{{item.name}}</li>
        </ul>
        <van-pullRefresh  v-model="page.refreshing" @refresh="onRefresh">
          <Empty v-if="page.totalCount === 0" />
          <van-list
            v-model="page.loading"
            :finished="page.finished"
            @load="onLoad"
            v-else
          >
            <OrderItem
              @cancel="cancel(item)"
              @clickBuy="pay(item)"
              v-for="(item,index) in page.list"
              :key="index"
              :obj="item"
              @click="handleItem(item)"
            />
            <template #finished>
              <van-divider style="width:50%;margin:20px auto;">滑到底啦</van-divider>
            </template>
          </van-list>
        </van-pullRefresh>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { Empty } from '@/components';
import { PullRefresh, Dialog } from 'vant';
import OrderItem from './components/OrderItem';
import { mapGetters } from 'vuex';
export default {
  name: 'Order',
  components: { Empty, 'van-pullRefresh': PullRefresh, OrderItem },
  data () {
    return {
      tabActive: 0,
      statusActive: 3,
      statusList: [{ name: '全部', key: 3 }, { name: '待付款', key: 0 }, { name: '已付款', key: 1 }, { name: '已取消', key: 2 }],
      page: {
        pageNo: 1,
        pageSize: 20,
        list: [],
        loading: false,
        finished: false,
        refreshing: false,
        totalCount: ''
      },

      /* 支付接口 */
      payWay: {
        1: 'course/h5/order', // 粤教培训
        2: 'lesson/h5/order', // 优秀案例
        3: 'resource/h5/orderRelease' // 教学资源
      },

      allInfo: {}
    };
  },
  computed: {
    ...mapGetters(['personInfo'])
  },
  watch: {
    tabActive () {
      this.$router.replace({
        query: {
          active: this.tabActive,
          status: this.statusActive
        }
      });

      if (this.statusActive === 3) {
        this.onRefresh();
      } else {
        this.statusActive = 3;
      };
    },
    statusActive () {
      this.$router.replace({
        query: {
          active: this.tabActive,
          status: this.statusActive
        }
      });
      this.onRefresh();
    }
  },

  mounted () {
    this.statusActive = this.$route.query.status * 1 || 3;
  },
  methods: {
    handleItem ({ courseId }) {
      if (this.tabActive === 0 || this.tabActive === 1) {
        this.$router.push({
          name: 'BookClassDetail',
          query: { id: courseId, active: this.tabActive }
        });
      } else {
        this.$router.push({
          name: 'BookDetail',
          query: { id: courseId }
        });
      }
    },
    onLoad () {
      const { page, statusActive, tabActive } = this;
      const params = {
        pageNo: page.pageNo,
        pageSize: page.pageSize,
        targetType: tabActive,
        status: statusActive
      };
      if (page.refreshing) {
        page.list = [];
        page.refreshing = false;
      }
      this.$http.get('order/findMyOrder', { params, showLoading: true }).then((res) => {
        const data = res.data || {};
        if (!data.isHasNext) {page.finished = true;}
        page.pageNo = data.nextPage;
        page.list.push(...data.result);
        page.loading = false;
        page.totalCount = data.totalCount;
        this.page = page;
      });
    },
    onRefresh () {
      // 清空列表数据 重新加载数据
      this.page = {
        pageNo: 1,
        pageSize: 20,
        list: [],
        loading: true,
        finished: false,
        refreshing: true
      };
      this.onLoad();
    },


    /* 支付 */
    pay (item) {
      const { $http, $utils } = this;
      this.allInfo = { id: item.targetId, integral: '', payType: 2, type: item.buyTarget, activationCode: '', orderNo: item.orderNo };
      if (!/MicroMessenger/.test(window.navigator.userAgent)) {
        $utils.toast('请前往微信客户端进行支付');
        return false;
      }
      $http.post('order/h5/pay', this.allInfo).then((res) => {
        const data = res.data || {};
        this.setWeiPay(data, (res) => {
          if (res.err_msg === 'get_brand_wcpay_request:ok') {
            this.isPay(data.orderId); // 轮询
          }
        });
      });
    },

    setWeiPay (data, callback) {
      if (typeof window.WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', this.weiPay(data, callback), false);
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', this.weiPay(data, callback));
          document.attachEvent('onWeixinJSBridgeReady', this.weiPay(data, callback));
        }
      } else {
        this.weiPay(data, callback);
      }
    },

    /* 唤起微信支付 */
    weiPay (data, callback) {
      console.log(data);
      window.WeixinJSBridge.invoke(
        'getBrandWCPayRequest', {
          'appId': data.appId, // 公众号名称，由商户传入
          'timeStamp': data.timeStamp, // 时间戳，自1970年以来的秒数
          'nonceStr': data.nonceStr, // 随机串
          'package': data.package,
          'signType': data.signType, // 微信签名方式：
          'paySign': data.paySign // 微信签名
        }, (res) => {
          callback && callback(res);
        }
      );
    },

    /* 循环调用支付 */
    isPay (id) {
      clearTimeout(this.timer);
      this.timer = setTimeout(async () => {
        const { result, data } = await this.$http.get('order/isPay', {
          params: {
            id
          },
          customError: true
        });
        if (result === 1 && data.payStatus === 1) {
          this.onRefresh();
        } else {
          this.isPay(id);
        }
      }, 1000);
    },


    /* 取消订单 */
    cancel (item) {
      const { $http, $utils } = this;
      Dialog.confirm({
        title: '提示',
        message: '您确定要取消这笔订单吗？'
      }).then(() => {
        $http.post('order/cancelMyOrder', {
          id: item.id
        }, {
          showLoading: true,
          loadingText: '取消中...'
        }).then((res) => {
          $utils.successToast('取消成功');
          item.status = 2;
        });
      }).catch(() => {
        // on cancel
      });

    }

  }
};
</script>

<style lang="less" scoped>
.order {
  background-color: #F7F8FA;
  height: calc(100vh - 94px);
  .statusList{
    display: flex;
    background-color: #F7F8FA;
    padding: 28px;
    .item{
      font-size: 28px;
      color: #333444;
      margin-right: 40px;
      &:last-child{
        margin-right: 0;
      }
      &.activeItem{
        color: #5FA9FF;
      }
    }
  }
}
</style>